import {PipeTransform, Pipe} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Pipe({
    name: 'trustAsUrl'
})
export class TrustAsUrlPipe implements PipeTransform {

    constructor(private _sanitizer: DomSanitizer) {
    }

    transform(value) {
        if (!value) {
            return value;
        }
        const url: SafeResourceUrl = this._sanitizer.bypassSecurityTrustResourceUrl(value);
        return url;
    }

}
